import { useIntl } from 'react-intl';

import Lookup from 'src/componentes/select2';

const TipoAcessoEstatico = ({ ...rest }) => {
  const intl = useIntl();

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      options={[
        {
          id: '1',
          descricao: intl.formatMessage({ id: 'semPermissao' }),
        },
        {
          id: '2',
          descricao: intl.formatMessage({ id: 'somenteLeitura' }),
        },
        {
          id: '3',
          descricao: intl.formatMessage({ id: 'alteracao' }),
        },
      ]}
      {...rest}
    />
  );
};

export default TipoAcessoEstatico;
